<template>
<v-container>
  <v-layout row wrap>
    <v-flex xs12 md12>
      <pdf-convert-view
      :pdf-name="fileName"
      :is-download="true"
      @onFinishConvert="onFinishConvert"
      ></pdf-convert-view>
    </v-flex>
  </v-layout>
</v-container>

</template>

<script>
import { mapActions, mapGetters } from "vuex";
import PdfConvertView from '../../components/PdfConvertView';

export default {
  name: "MergePdfView",
  components: {
    PdfConvertView
  },
  data() {
    return {
      fileName :''
    };
  },
  watch: {},
  computed: {
    
  },
  methods: {
    onFinishConvert(result) {
      console.log(`onFinishUpload === ${JSON.stringify(result)}`);
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/web/MergePdfView.vue